import { BaseController } from "./BaseController";

const OwnerConsoleViewAPI = BaseController.CreateAPI("ownerConsoleView");
export const OwnerConsoleViewController = {
	GetReportConfiguration: async (c?: string, trackView = false) => {
		try {
			if (!c) return undefined;
			var response = await OwnerConsoleViewAPI.get(
				`get-report-configuration?enc=${c}&track=${trackView ? 1 : 0}`,
			);
			if (response && response.status === 200) {
				return response.data;
			}
		} catch (err) {
			throw err;
		}
	},
	AddNewAdjustment: async (payload: {
		adjustment_type: number;
		adjustment_value: string;
		addrId: number | undefined;
		enc: string | undefined;
		track: boolean;
	}) => {
		try {
			var response = await OwnerConsoleViewAPI.post(`/add-owner-adjustment`, payload);
			if (response && response.status === 200) {
				const { adjustments } = response.data;
				return adjustments;
			}
		} catch (err) {
			throw err;
		}
	},
	DeleteAdjustment: async (payload: {
		adjustment_type_id: number;
		addrId: number;
		enc: string | undefined;
		track: boolean;
	}) => {
		try {
			var response = await OwnerConsoleViewAPI.post(`/delete-owner-adjustment`, payload);
			if (response && response.status === 200) {
				return response.data;
			}
		} catch (err) {
			throw err;
		}
	},
	// Mortgage Insights. Answers { mortgage } or throws with the server's message for the homeowner.
	SaveMortgage: async (payload: {
		enc: string | undefined;
		addrId: number;
		track: boolean;
		agentName?: string;
		estimatedValue?: number;
		lender: string | null;
		balance: number | string;
		rate: number | string;
		rateType: "fixed" | "variable";
		termEnd: string | null;
		payment?: number | string | null;
		yearsLeft?: number | null;
		consent: boolean;
	}) => {
		const response = await OwnerConsoleViewAPI.post(`/save-mortgage`, payload);
		if (response && response.status === 200) return response.data;
		throw new Error(response?.data?.message || "We couldn't save that. Please try again.");
	},
	RecordMortgagePrompt: async (payload: {
		enc: string | undefined;
		action: "shown" | "dismissed";
		track: boolean;
	}) => {
		try {
			await OwnerConsoleViewAPI.post(`/mortgage-prompt`, payload);
		} catch (err) {
			console.log(err);
		}
	},
	TrackMortgageClick: async (payload: { enc: string | undefined }) => {
		try {
			var response = await OwnerConsoleViewAPI.post(`/track-mortgage-click`, payload);
			if (response && response.status === 200) {
				return response.data;
			}
		} catch (err) {
			throw err;
		}
	},
};
